import React from "react";
import styled from "styled-components";

const TypoStyled = styled.div(({ $variant, size, $align }) => ({
  fontFamily: "Kodchasan, serif",
  fontWeight: $variant === "title" ? 700 : 400,
  fontStyle: "normal",
  fontSize: $variant === "title" ? "1.5rem" : "1rem",
  color: "#000",
  textAlign: $align,
  width: size === "small" ? "95%" : "100%",

  "@media (min-width: 768px)": {
    fontSize: $variant === "title" ? "2rem" : "1.2rem",
    width: size === "small" ? "70%" : "100%",
  },
}));

const Typo = ({ children, variant, size = "small", align = "center" }) => {
  return (
    <TypoStyled $variant={variant} size={size} $align={align}>
      {children}
    </TypoStyled>
  );
};

export default Typo;
